import { useSelector } from 'react-redux';
import { ProductType } from '@dev/ee-api/ee-api-models';
import { BillingType } from '@dev/ee-api/ee-api-models/billing-type';

import { getAccountStore } from '@/store/account/actions';
import { AccountState } from '@/store/account/types';

/**
 * For now this is the only way to determine if the account has legacy (till 2017Tier2) plan, or modern (unlimited, email api)
 *
 * @param {ProductType} accProductType account product type
 * @param {BillingType} accBillingType account billing type
 * @return {boolean} returns boolean
 */
const isLegacyPlan = (accProductType: ProductType, accBillingType: BillingType): boolean =>
    accProductType === ProductType.Marketing && accBillingType === BillingType.PayAsYouGo;

export const useSecurity = () => {
    const { AdvancedOptions, GeneralInfo }: AccountState = useSelector(getAccountStore);

    const hasLegacyPlan = isLegacyPlan(GeneralInfo?.ProductType, GeneralInfo?.BillingType);

    return {
        isReseller: AdvancedOptions?.IsOwnedByReseller,
        isProPlan: GeneralInfo?.IsPro,
        enableContactFeatures: GeneralInfo?.EnableContactFeatures,
        isApiPlan: GeneralInfo?.ProductType === ProductType.API,
        isMarketingPlan: GeneralInfo?.ProductType === ProductType.Marketing,
        isApiBillingPlan: GeneralInfo?.BillingType === BillingType.PayAsYouGo,
        hasLegacyPlan,
    };
};
